import { render, staticRenderFns } from "./templeteManage.vue?vue&type=template&id=c8e2bf78&scoped=true&"
import script from "./templeteManage.vue?vue&type=script&lang=js&"
export * from "./templeteManage.vue?vue&type=script&lang=js&"
import style0 from "./templeteManage.vue?vue&type=style&index=0&id=c8e2bf78&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e2bf78",
  null
  
)

export default component.exports